var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 14.25H13.875V12.375H15.75V11.625H13.875V9.75H13.125V11.625H11.25V12.375H13.125V14.25ZM13.5 15.75C12.4625 15.75 11.5782 15.3843 10.8472 14.6528C10.1163 13.9213 9.7505 13.037 9.75 12C9.7495 10.963 10.1153 10.0788 10.8472 9.34725C11.5793 8.61575 12.4635 8.25 13.5 8.25C14.5365 8.25 15.421 8.61575 16.1535 9.34725C16.886 10.0788 17.2515 10.963 17.25 12C17.2485 13.037 16.8828 13.9215 16.1528 14.6535C15.4228 15.3855 14.5385 15.751 13.5 15.75ZM3 14.25V5.25L9 0.75L15 5.25V6.975C14.7625 6.9 14.5188 6.84375 14.2687 6.80625C14.0187 6.76875 13.7625 6.75 13.5 6.75V6L9 2.625L4.5 6V12.75H8.30625C8.34375 13.0125 8.4 13.2687 8.475 13.5187C8.55 13.7688 8.64375 14.0125 8.75625 14.25H3Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.5f2eedb759ae35ed422faed6f875fa7c.svg";
export { ForwardRef as ReactComponent };